(function () {
  'use strict';
  const configElement = document.getElementById('jk-superior-only-config');
  if (!configElement || window.__jkSuperiorOnly) return;
  const config = JSON.parse(configElement.textContent);
  const variantId = String(config.variantId);
  const productId = String(config.productId);
  const expectedTitle = String(config.variantTitle).trim().toLowerCase();
  const observed = new WeakMap();
  let timer, pending = false;
  const norm = text => String(text || '').trim().toLowerCase();

  function component() {
    return Array.from(document.querySelectorAll('kaching-bundles-block')).find(el => {
      try { return String(JSON.parse(el.getAttribute('product') || '{}').id) === productId; }
      catch (_) { return false; }
    });
  }
  function current() {
    const widget = component();
    const bars = widget && widget.querySelector('.kaching-bundles__block > .kaching-bundles__bars');
    const bar = bars && bars.querySelector(':scope > .kaching-bundles__bar--selected');
    const title = bar && bar.querySelector('.kaching-bundles__bar-title')?.textContent;
    const count = /2\s*\+\s*2/.test(title || '') ? 4 : /1\s*\+\s*1/.test(title || '') ? 2 : 0;
    const selects = bar ? Array.from(bar.querySelectorAll('select.kaching-bundles__bar-variant-select')).filter(select =>
      !select.closest('.kaching-bundles__free-gift, .kaching-bundles__multiple-gifts-selector, .kaching-bundles__progressive-gifts, .kaching-bundles__subscriptions-wrapper') &&
      Array.from(select.options).some(option => norm(option.textContent) === expectedTitle)
    ) : [];
    return {widget, bars, bar, count, selects};
  }
  function forms() {
    return Array.from(document.querySelectorAll('form[action*="/cart/add"]')).filter(form =>
      String(form.querySelector('[name="product-id"]')?.value) === productId
    );
  }
  function bind(widget) {
    if (observed.has(widget)) return;
    const state = {items:null, bootstrapAttempts:0, bootstrapAt:0};
    observed.set(widget, state);
    widget.addEventListener('variants-changed', event => {
      state.items = Array.isArray(event.detail?.variantIdQuantities) ? event.detail.variantIdQuantities.map(item => ({variantId:String(item.variantId), quantity:Number(item.quantity)})) : null;
      schedule();
    });
    widget.addEventListener('deal-bar-selected', () => {state.items = null;state.bootstrapAttempts = 0;state.bootstrapAt = 0;schedule();});
    widget.addEventListener('change', () => schedule());
    widget.addEventListener('click', () => schedule());
  }
  function setSuperior(select) {
    const option = Array.from(select.options).find(item => norm(item.textContent) === expectedTitle);
    if (!option) return;
    const setter = Object.getOwnPropertyDescriptor(HTMLSelectElement.prototype, 'value').set;
    setter.call(select, option.value);
    select.dispatchEvent(new Event('input', {bubbles:true}));
    select.dispatchEvent(new Event('change', {bubbles:true}));
  }
  function verified() {
    const state = current();
    if (!state.widget || !state.count || state.selects.length !== state.count) return false;
    const domCorrect = state.selects.every(select => norm(select.selectedOptions[0]?.textContent) === expectedTitle);
    const items = observed.get(state.widget)?.items;
    const appCorrect = items && items.length > 0 && items.every(item => item.variantId === variantId && item.quantity > 0) && items.reduce((sum,item) => sum + item.quantity,0) === state.count;
    const ownForms = forms();
    const formCorrect = ownForms.length > 0 && ownForms.every(form => String(form.querySelector('[name="id"]')?.value) === variantId);
    return !!(domCorrect && appCorrect && formCorrect);
  }
  function sync() {
    const state = current();
    if (!state.widget) return;
    bind(state.widget);
    const wrong = state.selects.find(select => norm(select.selectedOptions[0]?.textContent) !== expectedTitle);
    if (wrong) {setSuperior(wrong);schedule();return;}
    const record = observed.get(state.widget);
    if (state.count && state.selects.length === state.count && !record.items && record.bootstrapAttempts < 5 && Date.now() - record.bootstrapAt > 250) {
      record.bootstrapAttempts++;
      record.bootstrapAt = Date.now();
      setSuperior(state.selects[0]);
      setTimeout(schedule,275);
      return;
    }
    for (const form of forms()) {
      const input = form.querySelector('[name="id"]');
      if (input && String(input.value) !== variantId) input.value = variantId;
    }
    document.documentElement.dataset.jkSuperiorReady = String(verified());
  }
  function schedule() { clearTimeout(timer);timer = setTimeout(sync,35); }
  function error(message) {
    let box = document.getElementById('jk-superior-only-error');
    if (!box) {box=document.createElement('p');box.id='jk-superior-only-error';box.setAttribute('role','alert');(current().bars || forms()[0])?.after(box);}
    box.textContent=message;
  }
  async function settle() {
    for (let attempt=0;attempt<20;attempt++) {
      sync();
      await new Promise(resolve=>setTimeout(resolve,75));
      if (verified()) return true;
    }
    return false;
  }
  function guard(event) {
    const button = event.type === 'click' ? event.target.closest('button, input[type="submit"]') : event.submitter;
    const form = event.type === 'submit' ? event.target : button?.form;
    if (!form || !forms().includes(form)) return;
    if (event.type === 'click' && button.type !== 'submit') return;
    if (verified()) return;
    event.preventDefault();event.stopImmediatePropagation();
    if (pending) return;
    pending = true;
    const formId = form.getAttribute('id');
    settle().then(ok=>{
      pending = false;
      if (!ok) {error('Dein Superior-Set konnte noch nicht geladen werden. Bitte lade die Seite neu und versuche es erneut.');return;}
      document.getElementById('jk-superior-only-error')?.remove();
      const targetForm = forms().find(item=>item.getAttribute('id')===formId) || forms().find(item=>item.querySelector('button[type="submit"]'));
      if (event.type==='click') {
        const targetButton = button.isConnected ? button : targetForm?.querySelector('button[type="submit"]');
        targetButton?.click();
      } else if (targetForm) {
        const submitter = button?.isConnected && button.form === targetForm ? button : undefined;
        targetForm.requestSubmit(submitter);
      }
    }).catch(()=>{pending=false;error('Bitte lade die Seite neu und versuche es erneut.');});
  }
  window.addEventListener('click',guard,true);
  window.addEventListener('submit',guard,true);
  window.addEventListener('pageshow',()=>{const widget=component();const state=widget&&observed.get(widget);if(state){state.items=null;state.bootstrapAttempts=0;state.bootstrapAt=0;}schedule();});
  function start() {
    new MutationObserver(mutations=>{
      if(mutations.some(mutation=>!mutation.target.parentElement?.closest('.jk-scent-picker,.kaching-bundles__timer')))schedule();
    }).observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['class','aria-checked','data-selling-plan-id']});
    sync();
  }
  window.__jkSuperiorOnly={verified, sync, config:{productId,variantId}};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
